// extracted by mini-css-extract-plugin
export default {"getTheAppCTA":"GetTheAppCTA--getTheAppCTA--SgFoJ","getTheAppCta":"GetTheAppCTA--getTheAppCTA--SgFoJ","appLinks":"GetTheAppCTA--appLinks--rOGAs"};